import {hasQueuedExports} from 'nutshell-core/session/has-queued-exports';

import {Dispatcher} from './infrastructure/dispatcher';

const $ = window.jQuery;

const {stream, push} = new Dispatcher();
const user = stream('USER_FETCH_RESPONSE').map('.users.0').startWith({isAdministrator: false});

function fetchUser(userId) {
    $.ajax({dataType: 'json', url: `/rest/users/${userId}`}).then((response) =>
        push('USER_FETCH_RESPONSE', response)
    );
}

// Tell the user stream what to do when its value changes
// in such a way that the queuedExports have changed.
user.filter((userModel) => userModel.id)
    .filter((userModel) => hasQueuedExports(userModel.notifyMessages))
    .debounce(2000)
    .onValue((userModel) => refreshUser(userModel.id));

// Export method for consumers
export function refreshUser(userId) {
    fetchUser(userId);
}

export default function (userId) {
    // Initial fetch of user
    fetchUser(userId);

    // Return user stream
    return user;
}
